"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChannelId = void 0;
/**
 * @returns number
 */
var getChannelId = function () {
    var element = document.getElementById("app");
    // 要素を取得できない場合は店舗側と判断する
    if (element === null) {
        return null;
    }
    var channelId = element.dataset.channelId;
    if (channelId === undefined) {
        return null;
    }
    return channelId;
};
exports.getChannelId = getChannelId;
